/* eslint-disable no-void */

import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios, { CancelTokenSource } from 'axios';

import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

type HookProps = {
  api: vp.Api;
};

type ReturnTuple = [
  vp.ApiResponse | undefined,
  (requestParams: vp.UpdateUserRolePermissionRequest) => void,
  (requestParams: vp.UpdateUserRolePermissionRequest) => Promise<vp.ApiResponse>,
  () => void,
];

function usePostDeleteUserRolePermission({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();

  const [params, setParams] = useState<vp.UpdateUserRolePermissionRequest>();
  const [response, setResponse] = useState<vp.ApiResponse>();
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  useEffect(() => {
    const sendRequest = async (
      requestParams: vp.UpdateUserRolePermissionRequest,
      cancelTokenSource: CancelTokenSource,
    ) => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen');

      const res = await api.postDeleteUserRolePermission(requestParams, cancelTokenSource);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params, source);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams: vp.UpdateUserRolePermissionRequest) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    async (requestParams: vp.UpdateUserRolePermissionRequest) => {
      const res = await api.postDeleteUserRolePermission(requestParams, source);

      return res;
    },
    () => {
      setResponse(undefined);
      setSendRequest(false);
    },
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(usePostDeleteUserRolePermission);
